export default __webpack_public_path__ + "static/media/schemat4.cac54c0c.png";